import React from 'react';
import ReporteSemanalReducido from './ReporteSemanalReducido';
import ReporteMensualReducido from './ReporteMensualReducido';

//import Modal from '../../comunes/Modal';
import { 
  faCalendarDay
  , faCalendarWeek
} from '@fortawesome/free-solid-svg-icons';

/* Links y Rutas Sidebar (Barra Vertical) */
export const ReporteNavTabs = [
  {
    title: 'Reporte Semanal',
    path: '#ReporteSemanal',
    icon: faCalendarWeek,
    cNameLi: 'nav-item',
    cNameA: 'nav-link active',
    dataToggle: 'tab'
  },
  {
    title: 'Reporte Mensual',
    path: '#ReporteMensual',
    icon: faCalendarDay,
    cNameLi: 'nav-item',
    cNameA: 'nav-link',
    dataToggle: 'tab'
  }
];

export const ReporteTabContent = [
    {
      id: 'ReporteSemanal',
      path: '#ReporteSemanal',
      component: <ReporteSemanalReducido />,
      cName: 'tab-pane fade active show',
    },
    {
      id: 'ReporteMensual',
      path: '#ReporteMensual',
      component: <ReporteMensualReducido />,
      cName: 'tab-pane fade',
    }
  ];